import React, { useMemo } from 'react'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import Tooltip from 'components/Luxkit/Tooltip'

interface Props{
  guideType: string
}

function TourV2GuideTypeToolTipInfo(props: Props) {
  const { guideType } = props

  const guideDescription = useMemo(() => {
    switch (guideType) {
      case 'Fully Guided Tour':
        return 'A tour with a tour director and driver with you throughout the entire trip, from start to finish.'
      case 'Partially Guided Tour':
        return 'A tour with a driver and local guides at specific locations or portions of the trip.'
      case 'Self-Guided Tour':
        return 'A tour where travellers explore independently without a dedicated guide.'
      default:
        return ''
    }
  }, [guideType])

  return (
    <Tooltip
      description={guideDescription}
    >
      <LineInfoCircleIcon colour="neutral-two" />
    </Tooltip>
  )
}

export default TourV2GuideTypeToolTipInfo
